import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import inventory from "../../../images/inventory.jpg";
const Inventory = (invt) => {
  const { _id, name, quantity, Price, description, supplier } = invt;
  const { inventoryId } = useParams();
  const [inventory, setInventory] = useState({});

  useEffect(() => {
    const url = `https://rocky-headland-86504.herokuapp.com/service/${inventoryId}`;
    fetch(url)
      .then((res) => res.json())
      .then((data) => setInventory(data));
  }, []);
  const int = [
    {
      _id: 1,
      name: "Camping Gears",
      quantity: "350",
      description:
        "Camping equipment  means tents, tarpaulins, lean-tos, huts, cardboard boxes, or similar make-shift temporary shelters produced",
      Price: "$5000",
      img: inventory,
      supplier: "Smily",
    },
  ];
  return (
    <div>
      <div className="gear-information">
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQM4vdOXbEk9jEhRbZj8BOS3OtxD6Lv3778dg&usqp=CAU"
          className="gear-img"
          alt=""
        />
        <h3 className="gear-name">Name:{name}</h3>
        <h5>Price: {Price}</h5>
        <h5>Quantity: {quantity}</h5>
        <h5>Supplier: {supplier}</h5>
        <h5>Description: {description}</h5>
        <Link to="/inventory/:inventoryId">
          <button className="btn-update">Update</button>
        </Link>
      </div>
    </div>
  );
};

export default Inventory;
